import { nextTick } from 'vue';
import dataLayerPush from '../utils/data-layer-push';
import { updateParameter } from '../quiz/history';
import scrollToSelector from '../utils/scroll-to-selector';
import { store } from '../../../../resources/frontend/js/store/index';
/**
 * Go to the next step
 */
export const goToNextStep = () => {
    const pageStore = store.state.page;

    store.commit('page/setValue', {
        key: 'previousStep',
        value: pageStore.step,
    });

    if (pageStore.step === pageStore.totalSteps - 1) {
        dataLayerPush('Form step 1');
    }

    pageStore.step++;
    pageStore.wrapper.setAttribute('data-step', pageStore.step);

    updateParameter(store, 'data_step', pageStore.step);

    if (!pageStore.wrapper.hasAttribute('data-no-step-scroll')) {
        scrollToSelector('body');
    }

    dataLayerPush(`Step ${pageStore.step}`);

    nextTick(() => {
        store.commit('cro/runStepChangeEvents', pageStore.step);

        if (document.querySelector(`.step--${pageStore.step} .question`)) {
            store.commit('page/increasePixelStep', { label: 'Question' });
            return;
        }

        if (document.querySelector(`.step--${pageStore.step} .loadingscreen`)) {
            store.commit('page/increasePixelStep', { label: 'Loading' });
            return;
        }

        if (document.querySelector(`.step--${pageStore.step} #form-wrapper`)) {
            store.commit('page/increasePixelStep', { label: 'Form' });
        }
    });
};

/**
 * Go to the previous step
 */
export const goToPreviousStep = () => {
    const pageStore = store.state.page;

    store.commit('page/setValue', {
        key: 'previousStep',
        value: pageStore.step,
    });

    if (step === 0) {
        pageStore.step--;
    } else {
        pageStore.step = step;
    }

    pageStore.wrapper.setAttribute('data-step', pageStore.step);

    if (!pageStore.wrapper.hasAttribute('data-no-step-scroll')) {
        scrollToSelector('body');
    }

    nextTick(() => {
        store.commit('cro/runStepChangeEvents', pageStore.step);

        if (pageStore.step === 1) {
            if (document.querySelector('.question')) {
                store.commit('page/decreasePixelStep', { label: 'Question' });
                return;
            }

            store.commit('page/decreasePixelStep', { label: 'Start' });
            return;
        }

        if (document.querySelector('.loadingscreen')) {
            store.commit('page/decreasePixelStep', { label: 'Loading' });
            return;
        }

        if (document.querySelector('#form-wrapper')) {
            store.commit('page/decreasePixelStep', { label: 'Form' });
        }
    });
};
